import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SearchViewComponentDef } from '@df/search/search-view.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsOutletBlockComponent } from '../../catalog/outlet-block/icms-outlet-block.component';
import { ProductListingComponent } from '../../catalog/ui/listing/product-listing.component';
import { NListing } from '../../catalog/ui/listing/product-listing.interface';
import { SearchBannerComponent } from './banner/search-banner.component';

export const searchResultEvent = 'search-result';

declare module '@df/search/search.interfaces' {
    namespace Search {
        interface ITerm {
            barePhrase: string;
        }
    }
}
@Component({
    selector: 'search-view',
    templateUrl: './search-view.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent, SearchBannerComponent, TranslationModule, SizeClassDirective, NgComponentOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchViewComponent extends SearchViewComponentDef implements OnInit {
    /**
     * Added search result event broadcast
     */
    override ngOnInit(): void {
        this.subscriptions.add(
            this.activatedRoute.data.subscribe(data => {
                this.result = data['searchResult'];
                this.app.events.broadcast(searchResultEvent, this.result);
                this.lastCategoryPath = this.router.url;
                this.onResultChange();
            })
        );
    }

    /**
     * returns true if product results exist
     */
    hasProductResults(): boolean {
        return !!this.result?.products?.length;
    }

    get listingOutlet(): NListing.IOutlet {
        return { component: ProductListingComponent, inputs: { searchResult: this.result, context: 'search', listing: this.listing } };
    }

    get useKlevu() {
        return true;
    }

    get noResultsTitle(): string {
        return `Sorry, we couldn't find any results for '%' `;
    }

    get noResultsText(): string | undefined {
        return;
    }

    get resultTitle(): string {
        return "Search results for '%'";
    }
}
